import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Modal, Row} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';

import DefaultImgPlaceholder from 'assets/images/default-placeholder.jpg';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import StarRating from 'Common/StarRating';

const NotifyMeListTable = (): JSX.Element => {
  document.title = 'Notified Products | Admin';
  const defaultPage = 1;
  const [pageValue, setPageValue] = useState(defaultPage);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(defaultPage);
  const currentData = Math.ceil(totalRecords / 10);
  const [list, setList]: any[] = useState();
  const [search, setSearch] = useState<string>('');
  // const sortColumn = 'notify.id';
  const [sortColumn, setSortColumn] = useState('notify.id');

  const [sortDirection, setSortDirection] = useState('asc');

  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);

  // Fetch categories on component mount
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        const res: any = await ApiUtils.getCategory();
        const mappedData = res?.data?.map((data: any) => ({
          value: data?.id,
          label: data?.name,
        }));
        setCategories(mappedData);
      } catch (err: any) {
        toast.error(err?.message);
      }
    };

    void fetchData();
  }, []);

  const getCategoryLabel = (categoryId: number): string => {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    const category: any = categories.find(
      (cat: any) => cat?.value === categoryId,
    );
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    return category ? category?.label : 'Unknown Category';
  };
  const handleImageClick = (product: any): void => {
    console.log('🚀 ~ handleImageClick ~ product:', product);
    // setSelectedProduct(product);
    // setIsModalOpen(true);
    window.open(
      `${process.env.REACT_APP_FRONTEND_URL}/product/${product?.product_id}?option=${product?.product_option_value_id}`,
    );
  };

  const closeModal = (): void => {
    setSelectedProduct(null);
    setIsModalOpen(false);
  };

  async function getWishlist(): Promise<void> {
    try {
      const response: any = await ApiUtils.getNotifiedItemList(
        `page_size=${pageSize}&page=${pageValue}&search=${search}&sort_column=${sortColumn}&sort_direction=${sortDirection}`,
      );
      setList(response.data.data ?? []);
      setTotalRecords(response.data.total);
    } catch (error: any) {
      toast.error(error.message);
    }
  }

  useEffect(() => {
    void getWishlist();
  }, [pageValue, pageSize, search]);

  const handleSortByColumn = async (column: string): Promise<void> => {
    try {
      let newSortDirection = 'asc';

      if (column === sortColumn) {
        newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        newSortDirection = 'desc';
      }

      const response: any = await ApiUtils.getNotifiedItemList(
        `page_size=${pageSize}&page=${pageValue}&search=${search}&sort_column=${column}&sort_direction=${newSortDirection}`,
      );
      setList(response.data.data ?? []);
      setSortDirection(newSortDirection);
      setTotalRecords(response.data.total);
      setSortColumn(column);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };
  const handleSearch = (value: string): void => {
    setSearch(value);
  };
  const columns = [
    {
      Header: 'Customer ID',
      disableFilters: true,
      filterable: true,
      accessor: 'customer_id',
      Cell: (cell: any) => {
        return <div>{(cell.value as boolean) ? cell.value : '-'}</div>;
      },
    },
    {
      Header: 'Product Name',
      accessor: 'product_name',
      Cell: ({cell}: {cell: any}) => (
        <div
          className="d-flex align-items-center"
          onClick={() => {
            handleImageClick(cell.row.original);
            console.log(
              '🚀 ~ NotifyMeListTable ~ cell.row.original:',
              cell.row.original,
            );
          }}
          style={{cursor: 'pointer'}}>
          <div className="flex-shrink-0 me-3">
            <div className="avatar-title bg-light rounded">
              <img src={cell.row.original.image} alt="" className="avatar-xs" />
            </div>
          </div>
          <div className="clickable-text">{cell.row.original.product_name}</div>
        </div>
      ),
    },

    // {
    //   Header: 'Product Name',
    //   Cell: ({cell}: {cell: any}) => {
    //     return (
    //       <div className="d-flex align-items-center">
    //         <div className="flex-shrink-0 me-3">
    //           <div className="avatar-title bg-light rounded">
    //             <img
    //               src={cell.row.original.image}
    //               alt=""
    //               className="avatar-xs"
    //             />
    //           </div>
    //         </div>
    //         <div>{cell.row.original.product_name}</div>
    //       </div>
    //     );
    //   },
    // },
    {
      Header: 'Customer Name',
      disableFilters: true,
      filterable: true,
      accessor: 'customer_first_name',
      Cell: (cell: any) => {
        const fullName = cell.row.original.name; // Access the 'name' property from the original data
        return <div>{(fullName as boolean) ? fullName : '-'}</div>;
      },
    },
    {
      Header: 'Customer Email',
      disableFilters: true,
      filterable: true,
      accessor: 'customer_email',
      Cell: (cell: any) => {
        return <div>{(cell.value as boolean) ? cell.value : '-'}</div>;
      },
    },
    {
      Header: 'Customer Phone Number',
      disableFilters: true,
      filterable: true,
      accessor: 'customer_phone',
      Cell: (cell: any) => {
        return <div>{(cell.value as boolean) ? cell.value : '-'}</div>;
      },
    },
    {
      Header: 'Amount',
      disableFilters: true,
      filterable: true,
      accessor: 'price',
      Cell: (cell: any) => {
        return <div>{(cell.value as boolean) ? cell.value : '-'}</div>;
      },
    },
  ];
  const notifiesItemList = list?.map((data: any) => {
    return {
      customer_id: data?.customer_id,
      name: data?.customer_first_name + ' ' + data?.customer_last_name,
      price: data?.special_price,
      product_name: data?.product_name,
      product_sku: data?.product_sku,
      color: data?.option_value_name,
      rating: data?.rating,
      rating_count: data?.rating_count,
      category_name: data?.category_name,
      image:
        data?.product_option_value_image != null
          ? data?.product_option_value_image[0]?.image
          : DefaultImgPlaceholder,
      product_id: data?.product_id,
      product_option_value_id: data?.product_option_value_id,
      customer_email: data?.customer_email,
      customer_phone: data?.customer_phone,
    };
  });
  return (
    <Row>
      <Col lg={12}>
        <Card id="invoiceList">
          <Card.Body>
            <div>
              <TableContainer
                columns={columns ?? []}
                data={notifiesItemList ?? []}
                isGlobalFilter={true}
                handleNextPagination={handleNextPagination}
                handlePrevPagination={handlePrevPagination}
                pageValue={pageValue}
                iscustomPageSize={false}
                isBordered={true}
                customPageSize={pageSize}
                pageSize={pageSize}
                currentData={currentData}
                setPageSize={setPageSize}
                // isAddOptions={true}
                className="custom-header-css"
                tableClass="table-centered align-middle table-nowrap mb-0"
                theadClass="text-muted table-light"
                SearchPlaceholder="Search product name or customer name"
                onSearch={handleSearch}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
                handleSortByColumn={handleSortByColumn}
              />
              <div className="noresult" style={{display: 'none'}}>
                <div className="text-center">
                  <h5 className="mt-2">Sorry! No Result Found</h5>
                  <p className="text-muted mb-0">All Products are in stocks</p>
                </div>
              </div>
            </div>

            {/* Modal for Product Details */}
            <Modal show={isModalOpen} onHide={closeModal}>
              <Modal.Header closeButton>
                <Modal.Title>Product Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* Render product details inside the modal */}
                {Boolean(selectedProduct) && (
                  <div>
                    <img
                      src={selectedProduct?.image}
                      className="avatar-xl"
                      alt="Error"
                      style={{width: '200px', height: '200px'}}
                    />
                    <p>
                      <strong>Product Name: </strong>
                      {selectedProduct?.product_name}
                    </p>
                    <p>
                      <strong>Product SKU: </strong>
                      {selectedProduct?.product_sku}
                    </p>
                    <p>
                      <strong>Product Color: </strong>
                      {selectedProduct?.color}
                    </p>
                    <p>
                      <strong>Product Price: </strong>₹ {selectedProduct?.price}
                    </p>
                    <p>
                      <strong>Product Rating: </strong>
                      <StarRating
                        rating={selectedProduct?.rating}
                        totalStars={5}
                      />
                    </p>
                    <p>
                      <strong>Number of Customer Rated: </strong>
                      {selectedProduct?.rating_count}
                    </p>
                    <p>
                      <strong>Product Category: </strong>
                      {getCategoryLabel(selectedProduct?.category_name)}
                    </p>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default NotifyMeListTable;
